import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ReactInputMask from "react-input-mask";
//primereact
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Modal from "../modal/Modal";
import Input from "../input/Input";
import Select from "../input/Select";
import MaskInput from "../input/MaskInput";
//utils
import { states } from "../../utils/states";
import { handleCep } from "../../utils/handleCep";

const ModalClientData = ({
  noData,
  visible,
  searchDoc,
  setVisible,
  activeIndex,
  baseDataForm,
  setActiveIndex,
  creditCardClient,
  setCreditCardClient,
}) => {
  const [address, setAddress] = useState(null);
  const [doc, setDoc] = useState("");
  const [mask, setMask] = useState("999.999.999-99");
  const form = useForm();
  const errors = form.formState.errors;
  const steps = [
    ...(typeof noData === 'undefined' ? [{ label: "Dados do Titular" }] : []),
    { label: "Endereço do Titular" },
  ];

  const watchMask = (value) => {
    if (value.length <= 14) {
      setMask("999.999.999-999");
      setDoc(value);
    } else {
      setMask("99.999.999/9999-99");
      setDoc(value);
    }
  };


  const onSubmitData = (data) => {
    const {
      cep,
      num,
      complement,
      city,
      state,
      address,
      neighborhood,
      ...filteredData
    } = data;

    setCreditCardClient((prevData) => ({
      ...prevData,
      data: {
        ...filteredData,
      },
    }));
    setActiveIndex(1);
  };

  const onSubmitAddress = (data) => {
    const { customer_doc, customer_email, customer_name, customer_phone, ...filteredAddress } =
      data;

    setCreditCardClient((prevData) => ({
      ...prevData,
      address: {
        ...filteredAddress,
      },
    }));
    setVisible(false);
  };

  const handleDoc = (doc) => {
    if (searchDoc) {
      const getDocIndex = () => {
        return baseDataForm?.doc.findIndex((d) => d === doc);
      };
      const docIndex = getDocIndex();
      if (doc === baseDataForm?.doc_enterprise) {
        form.setValue("customer_doc", baseDataForm.doc_enterprise);
        form.setValue("customer_name", baseDataForm.name_enterprise);
        form.setValue("customer_email", baseDataForm.email_enterprise);
      } else if (docIndex !== -1) {
        form.setValue("customer_doc", baseDataForm.doc[docIndex]);
        form.setValue("customer_name", baseDataForm.name[docIndex]);
        form.setValue("customer_email", baseDataForm.email[docIndex]);
      } else {
        form.setValue("customer_doc", doc);
        form.setValue("customer_name", "");
        form.setValue("customer_email", "");
      }
    } else {
      form.setValue("customer_doc", doc);
    }
  };

  useEffect(() => {
    if (creditCardClient) {
      // console.log(creditCardClient);
      form.setValue("customer_doc", creditCardClient.data?.customer_doc);
      setDoc(creditCardClient.data?.customer_doc);
      form.setValue("customer_email", creditCardClient.data?.customer_email);
      form.setValue("customer_name", creditCardClient.data?.customer_name);
      form.setValue("cep", creditCardClient.address?.cep);
      form.setValue("num", creditCardClient.address?.number);
      form.setValue("complement", creditCardClient.address?.complement);
      form.setValue("city", creditCardClient.address?.city);
      form.setValue("state", creditCardClient.address?.state);
      form.setValue("address", creditCardClient.address?.address);
      form.setValue("neighborhood", creditCardClient.address?.neighborhood);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditCardClient]);

  useEffect(() => {
    if (address && Object.keys(address).length !== 0) {
      form.setValue("address", address.address);
      form.setValue("city", address.city);
      form.setValue("neighborhood", address.neighborhood);
      form.setValue("state", address.state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  useEffect(() => {
    if (activeIndex === 1 && baseDataForm?.cep && !address) {
      // console.log(baseDataForm);
      const handleAcceptAddress = () => {
        form.setValue("cep", baseDataForm.cep);
        form.setValue("number", baseDataForm.num);
        form.setValue("city", baseDataForm.city);
        form.setValue("state", baseDataForm.state);
        form.setValue("address", baseDataForm.address);
        form.setValue("complement", baseDataForm.complement);
        form.setValue("neighborhood", baseDataForm.neighborhood);
        handleCep(baseDataForm.cep, setAddress);
      };
      confirmDialog({
        message: `Os dados do endereço são: ${baseDataForm.address} - ${baseDataForm.cep}?`,
        header: "Importação de Dados",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => handleAcceptAddress(),
      });
    }
  }, [activeIndex, address]);

  return (
    <Modal
      header="Dados do Titular"
      visible={visible}
      dynamicWidth={window.innerWidth <= 992 ? "85vw" : "50vw"}
      onHide={() => setVisible(false)}
    >
      <Steps
        model={steps}
        className="mt-2"
        activeIndex={activeIndex}
        onSelect={(e) => setActiveIndex(e.index)}
        readOnly={false}
      />
      {activeIndex === 0 && !noData && (
        <>
          <form onSubmit={form.handleSubmit(onSubmitData)}>
            <div className="row my-4">
              <div className="col-md-6">
                <ReactInputMask
                  mask={mask}
                  maskChar={null}
                  value={doc}
                  required
                  {...form.register("customer_doc")}
                  onChange={(event) => watchMask(event.target.value)}
                  onBlur={(e) => handleDoc(e.target.value)}
                  placeholder="CPF / CNPJ *"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ced4da",
                    marginTop: "24px",
                    borderRadius: "5px",
                  }}
                  className={`input-cpf ${doc ? "input-filled" : ""}`}
                />
              </div>
              <div className="col-md-6">
                <Input
                  isRequired
                  name="customer_name"
                  errors={errors}
                  control={form.control}
                  onComplete={() => form.setFocus("name")}
                  label={`Nome do Titular *`}
                />
              </div>
              <div className="col-md-6">
                <Input
                  isRequired
                  name="customer_email"
                  errors={form.formState.errors}
                  control={form.control}
                  type="email"
                  validationRules={{
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "E-mail inválido.",
                    },
                  }}
                  label="E-mail *"
                />
              </div>
              <div className="col-md-6">
                <MaskInput
                  name={`customer_phone`}
                  mask="(99) 99999-9999"
                  control={form.control}
                  isRequired
                  errors={form.formState.errors}
                  label={`Telefone *`}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="col-md-2">
                <Button
                  rounded
                  type="submit"
                  label="Salvar"
                  icon="fa-solid fa-check"
                  className="w-100"
                  // onClick={handleSubmit}
                />
              </div>
            </div>
          </form>
        </>
      )}
      {((!noData && activeIndex === 1) || (noData && activeIndex === 0)) && (
        <>
          <form onSubmit={form.handleSubmit(onSubmitAddress)}>
            <div className="row gx-3 my-4">
              <div className="col-md-3">
                <MaskInput
                  name="cep"
                  // placeholder="Digite o CEP"
                  mask="99999-999"
                  onComplete={() => handleCep(form.getValues("cep"), setAddress)}
                  control={form.control}
                  errors={form.formState.errors}
                  isRequired
                  label={`CEP *`}
                />
              </div>
              <div className="col-md-3">
                <Input
                  name="number"
                  control={form.control}
                  errors={form.formState.errors}
                  // placeholder="N.º"
                  label={`Número *`}
                  isRequired
                />
              </div>
              <div className="col-md-6">
                <Input
                  name="complement"
                  control={form.control}
                  errors={form.formState.errors}
                  // placeholder="Ex: Bloco A, apartamento 25"
                  label={`Complemento`}
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="city"
                  control={form.control}
                  errors={form.formState.errors}
                  defaultValue={address?.city}
                  // placeholder="Digite a Cidade"
                  label={`Cidade *`}
                  isRequired
                />
              </div>

              <div className="col-md-3 mt-2">
                <Select
                  name="state"
                  label={`Estado *`}
                  errors={form.formState.errors}
                  preValue={address?.state}
                  control={form.control}
                  options={states}
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="address"
                  control={form.control}
                  errors={form.formState.errors}
                  defaultValue={address?.address}
                  // placeholder="Ex: R. Catia Setima Montagni"
                  label={`Rua *`}
                  isRequired
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="neighborhood"
                  control={form.control}
                  errors={form.formState.errors}
                  defaultValue={address?.neighborhood}
                  // placeholder="Ex: Centro"
                  label={`Bairro *`}
                  isRequired
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="col-md-2">
                <Button
                  rounded
                  type="submit"
                  label="Salvar"
                  icon="fa-solid fa-check"
                  className="w-100"
                  // onClick={handleSubmit}
                />
              </div>
            </div>
          </form>
        </>
      )}
    </Modal>
  );
};

export default ModalClientData;
